
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkLedgerModeEnum } from '../models/work-ledger-mode-enum';
import { WorkAccountSelectionModeEnum } from '../models/work-account-selection-mode-enum';

export function getUpdateAccountingSettingsDtoFormGroup() {
return new FormGroup({
    ledgerMode: new FormControl<WorkLedgerModeEnum | undefined>(undefined),
    exportConnectorKey: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    testMode: new FormControl<boolean | undefined>(undefined),
    ownCompanyNames: new FormControl<Array<string> | undefined>([]),
    payablesControlAccountId: new FormControl<number | undefined>(undefined),
    accountSelectionMode: new FormControl<WorkAccountSelectionModeEnum | undefined>(undefined),
    creditNoteCode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    invoiceCode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    attachPdf: new FormControl<boolean | undefined>(undefined),
    bookOnApproval: new FormControl<boolean | undefined>(undefined),
    legacyExpenseAccountId: new FormControl<number | undefined>(undefined),
})
;
}
      